import { PERKS, PERK_PRICE, BUNDLE_PRICE } from "@/components/forest/perks";

export default function Features() {
  return (
    <section
      id="features"
      data-testid="features-section"
      className="relative py-24 md:py-32"
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl">
          <p className="text-xs uppercase tracking-[0.2em] text-emerald-300 font-bold">
            What's in the bundle
          </p>
          <h2
            data-testid="features-title"
            className="font-serif text-4xl sm:text-5xl mt-3 text-white leading-tight"
          >
            Pick any. Or grab them <span className="text-amber-400">all for $20.</span>
          </h2>
          <p className="mt-4 text-emerald-100/70 text-base md:text-lg">
            Each perk is <span className="text-amber-400 font-bold">${PERK_PRICE}</span> on its own.
            Want the whole forest survival kit? All six together is just
            <span className="text-amber-400 font-bold"> ${BUNDLE_PRICE}</span> — your biggest save.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-5">
          {PERKS.map((p) => {
            const Icon = p.icon;
            return (
              <div
                key={p.id}
                data-testid={`perk-${p.id}`}
                className={`group relative overflow-hidden rounded-3xl p-7 backdrop-blur-xl bg-[#081622]/60 border border-emerald-900/40 hover:-translate-y-1 hover:border-amber-500/40 transition-all duration-300 shadow-[0_8px_32px_rgba(0,0,0,0.5)] ${
                  p.big ? "md:col-span-2 md:row-span-1" : ""
                }`}
              >
                <div className="absolute -top-20 -right-20 w-48 h-48 rounded-full bg-amber-500/10 blur-3xl opacity-0 group-hover:opacity-100 transition" />
                <div className="relative">
                  <div className="flex items-start justify-between gap-3">
                    <div className="w-12 h-12 rounded-2xl grid place-items-center bg-[#0a1a2e] border border-emerald-900/60 group-hover:border-amber-500/50 transition">
                      <Icon className="w-6 h-6 text-amber-400" />
                    </div>
                    <span
                      data-testid={`perk-price-${p.id}`}
                      className="font-serif text-2xl text-amber-400 leading-none mt-1"
                    >
                      ${PERK_PRICE}
                    </span>
                  </div>
                  <h3 className="mt-5 font-serif text-2xl text-white">
                    {p.title}
                  </h3>
                  <p className="mt-2 text-emerald-100/70 text-sm md:text-base leading-relaxed">
                    {p.desc}
                  </p>
                  {p.big && (
                    <p className="mt-5 text-xs uppercase tracking-[0.15em] text-amber-400/80 font-bold">
                      Crowd favorite
                    </p>
                  )}
                </div>
              </div>
            );
          })}
        </div>

        <div
          data-testid="bundle-callout"
          className="mt-8 rounded-3xl border border-amber-500/40 bg-[#1a0e00]/40 backdrop-blur-xl p-6 sm:p-8 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4"
        >
          <div>
            <p className="text-xs uppercase tracking-[0.18em] text-amber-300 font-bold">
              Best value
            </p>
            <p className="font-serif text-2xl text-white mt-1">
              All 6 perks · the full forest bundle
            </p>
            <p className="text-sm text-emerald-100/70 mt-1">
              Save ${PERKS.length * PERK_PRICE - BUNDLE_PRICE} vs. buying each one.
            </p>
          </div>
          <div className="flex items-baseline gap-3">
            <span className="text-emerald-100/50 line-through font-serif text-xl">
              ${PERKS.length * PERK_PRICE}
            </span>
            <span className="font-serif text-4xl text-amber-400">
              ${BUNDLE_PRICE}
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}
